class PageLoader{
    constructor(){
        this.preloader = document.querySelector('.preloader');
        window.addEventListener('load', function() {this.fadeEffect});
    }
    
    fadeEffect = setInterval(() => {
        // if we don't set opacity 1 in CSS, then
        // it will be equaled to "" -- that's why
        // we check it, and if so, set opacity to 1
        if (!this.preloader.style.opacity) {
            this.preloader.style.opacity = 1;
        }
        if (this.preloader.style.opacity > 0) {
            this.preloader.style.opacity -= 0.1;
        } else {
            clearInterval(this.fadeEffect);
            this.preloader.classList.add('hidden');
        }
    }, 1);
    
}
export default PageLoader